import { c as _c } from "react/compiler-runtime";
import { Title } from "@justhome/react-ui";
import useLinks from "@lib/hooks/useLinks";
import EmbedLayout from "@modules/application/components/EmbedLayout";
import MaximumBudgetCard from "@modules/application/components/MaximumBudgetCard";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { useRouter } from "@lib/hooks/useRouter";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FormStepComponent } from "../FormSteps/FormSteps";
const EmbeddedBudgetFinalScreen: FC<FormStepComponent<BudgetCheckFormValues>> = t0 => {
  const $ = _c(23);
  const {
    currentStepNumber,
    numberOfSteps
  } = t0;
  const {
    t
  } = useTranslation("budget-check");
  const router = useRouter();
  const {
    state: t1
  } = useApplicationContext();
  const {
    maximumBudget
  } = t1;
  const {
    getApplicationProcessLink
  } = useLinks();
  let t2;
  let t3;
  if ($[0] !== getApplicationProcessLink || $[1] !== maximumBudget || $[2] !== router) {
    t2 = () => {
      if (!maximumBudget) {
        router.push(getApplicationProcessLink("budget-check"));
      }
    };
    t3 = [maximumBudget, getApplicationProcessLink, router];
    $[0] = getApplicationProcessLink;
    $[1] = maximumBudget;
    $[2] = router;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!maximumBudget) {
    return null;
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("result_title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Title as="h1" className="text-h1 mb-3s text-balance">{t4}</Title>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== maximumBudget) {
    t6 = <MaximumBudgetCard maximumBudget={maximumBudget} className="mb-3s" />;
    $[9] = maximumBudget;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("result_note");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <p className="text-body-2">{t7}</p>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t8) {
    t9 = <div className="grow flex flex-col items-center"><div className="flex flex-col">{t5}{t6}{t8}</div></div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== currentStepNumber || $[20] !== numberOfSteps || $[21] !== t9) {
    t10 = <EmbedLayout><EmbedLayout.Body showProgress={false} currentStepNumber={currentStepNumber} numberOfSteps={numberOfSteps} state={currentStepNumber}>{t9}</EmbedLayout.Body></EmbedLayout>;
    $[19] = currentStepNumber;
    $[20] = numberOfSteps;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default EmbeddedBudgetFinalScreen;